import { ProjecaoFormularioView } from "../../projecao-formulario/view-projecao-formulario";
import { RESUMO_CAMPOS, RESUMO_TITLE } from "./etapa-projecao.constants";
import styles from "./etapa-projecao.module.scss";
import type { EtapaProjecaoViewModel } from "./types-etapa-projecao";

export function EtapaProjecaoView({ resumo, ...formulario }: EtapaProjecaoViewModel) {
  return (
    <section className={styles.etapa} data-testid="adicionar-escopo-projecao">
      <section
        className={styles.resumo}
        aria-label={RESUMO_TITLE}
        data-testid="adicionar-escopo-resumo"
      >
        <dl className={styles.campos}>
          {RESUMO_CAMPOS.map(({ campo, rotulo, testId }) => (
            <div key={campo} className={styles.campo}>
              <dt className={styles.rotulo}>{rotulo}</dt>
              <dd className={styles.valor} data-testid={testId}>
                {resumo[campo]}
              </dd>
            </div>
          ))}
        </dl>
      </section>
      <ProjecaoFormularioView {...formulario} />
    </section>
  );
}
